<section class="navbar-header d-none d-md-block" [class.scrolled]="isScrolled">
  <p-toast position="bottom-right"></p-toast>

  <ng-template #searchNav>
    <div class="search-input" *ngIf="!disableSearch">
      <input type="text" (keyup.enter)="searchResult()" [(ngModel)]="searchTerm" class="input-main"
        [placeholder]="'navbar.search.placeholder' | translate" />
      <i class="pi pi-search search-icon end-0" (click)="searchResult()"></i>
      <i *ngIf="searchTerm" class="clear-btn pi pi-times " (click)="clearSearch()"></i>
    </div>
  </ng-template>

  <ng-template #navIcons>
    <div class="d-flex align-items-center">
      <!-- new currency list -->
      <div class="item">
        <app-nav-regional></app-nav-regional>
      </div>

      <!-- theme toggle -->
      <button class="theme-toggle border-0" type="button" (click)="toggleTheme()"
        [attr.aria-label]="isLight ? 'Dark mode' : 'Light mode'">
        <i class="pi" [ngClass]="isLight ? 'pi-moon' : 'pi-sun'"></i>
      </button>

      <ng-template #auth>
        <!-- bell button -->
        <div class="icon-item bell">
          <app-nav-notifications></app-nav-notifications>
        </div>

        <div class="icon-item shop">
          <app-nav-cart></app-nav-cart>
        </div>

        <!-- user list -->
        <div class="icon-item user">
          <button class="border-0 overlay-panel-toggle user-icon pic p-0" (click)="userSettingOP.toggle($event)">
            <p *ngIf="!user$()?.avatar">{{ user$()?.name?.slice(0, 2) }}</p>
            <img loading="lazy" *ngIf="user$()?.avatar" [src]="user$()?.avatar" [alt]="user$()?.name" width="30"
              height="30" class="rounded-circle" />
          </button>
          <p-overlayPanel #userSettingOP>
            <div class="user-dropdown">
              <ul class="user-list list-unstyled rounded-3" (click)="userSettingOP.toggle($event)">
                <!-- User Info -->
                <li class="user-setting-link username">
                  <span class="user-icon border-0 ps-0">
                    <p *ngIf="!user$()?.avatar">{{ user$()?.name?.slice(0, 2) }}</p>
                    <img loading="lazy" *ngIf="user$()?.avatar" [src]="user$()?.avatar" [alt]="user$()?.name" width="30"
                      height="30" class="rounded-circle me-2" />
                  </span>
                  <div class="customer">
                    <span class="customer-name">
                      {{ user$()?.name }}
                    </span>
                    <span class="customer-email">
                      {{ user$()?.email }}
                    </span>
                  </div>
                </li>

                <!-- User Links -->
                <li class="user-setting-link" routerLink="/{{langCode$()}}/settings/profile" routerLinkActive="active">
                  <i class="pi pi-user"></i> {{ 'navbar.userMenu.profile' | translate }}
                </li>
                <li class="user-setting-link" routerLink="/{{langCode$()}}/settings/orders" routerLinkActive="active">
                  <i class="pi pi-book"></i> {{ 'navbar.userMenu.orders' | translate }}
                </li>
                <li class="user-setting-link" routerLink="/{{langCode$()}}/settings/wallets" routerLinkActive="active"
                  *ngIf="!showWallet">
                  <i class="pi pi-wallet"></i> {{ 'navbar.userMenu.wallets' | translate }}
                </li>
                <li class="user-setting-link" routerLink="/{{langCode$()}}/settings/tickets" routerLinkActive="active">
                  <i class="pi pi-ticket"></i> {{ 'navbar.userMenu.tickets' | translate }}
                </li>
                <li class="user-setting-link" routerLink="/{{langCode$()}}/settings/notification"
                  routerLinkActive="active">
                  <i class="pi pi-bell"></i>
                  <div class="label">
                    {{ 'navbar.userMenu.notification' | translate }}
                    <div class="count" *ngIf="unreadNotificationCount">{{unreadNotificationCount > 99 ? '+99' :
                      unreadNotificationCount}}</div>
                  </div>
                </li>

                <!-- Logout -->
                <li class="user-setting-link logout" (click)="logout(); userListNav = false">
                  <i class="pi pi-sign-out"></i>
                  {{ 'navbar.userMenu.logout' | translate }}
                </li>
              </ul>
            </div>
          </p-overlayPanel>
        </div>

        <!-- wallets list -->
        <div class="icon-item log" *ngIf="(wallets?.length && selectedWallet != {}) && !showWallet"
          style="cursor: pointer;" routerLink="/{{langCode$()}}/settings/wallets/add-balance/{{selectedCurrency.key}}">
          <div class="d-flex align-items-center balance" style="flex-grow: 1; text-wrap-mode: nowrap;">
            <i class="fa-solid fa-coins coins-icon"></i>
            {{ selectedWallet.balance | number : "1.2" }}
            {{ selectedWallet.currency }}
          </div>
        </div>
      </ng-template>

      <ng-template #notAuth>
        <div class="dropdown">
          <button class="btn-main position-relative ms-2 glass dropdown-toggle border-0" type="button"
            name="parentlogin" data-bs-toggle="dropdown" aria-expanded="false">
            {{ 'navbar.auth.login' | translate }}
          </button>
          <ul class="dropdown-nav dropdown-menu login">
            <div class="login-list d-flex flex-column align-items-center justify-content-center">
              <img loading="lazy" src="assets/images/navbar/drop-downs/login.webp" alt="" width="144" height="146" />
              <button class="btn-main w-100 mb-3" routerLink="/{{langCode$()}}/auth/signin" name="login">
                {{ 'navbar.auth.login' | translate }}
              </button>
              <button class="btn-main w-100 glass" routerLink="/{{langCode$()}}/auth/signup" name="signup">
                {{ 'navbar.auth.signup' | translate }}
              </button>
            </div>
          </ul>
        </div>
      </ng-template>
      <ng-container *ngIf="userLogin$() && user$() ; then auth; else notAuth"></ng-container>
    </div>
  </ng-template>

  <!-- desktop-nav -->
  <nav class="navbar navbar-expand-md navbar-dark desktop-nav">
    <div class="container-fluid container-sm py-2 py-lg-0">
      <div class="nav-img">
        <!-- desktop logo -->
        <div class="logo d-none d-lg-flex align-items-center">
          <img loading="lazy" class="logo-img d-none d-lg-block"
            [src]="isLight ? 'assets/images/navbar/logo-light.svg' : 'assets/images/navbar/logo-dark.svg'"
            alt="card4games logo" routerLink="/{{langCode$()}}" />
        </div>
        <!-- phone logo -->
        <span class="logo d-flex align-items-center d-lg-none me-3">
          <img loading="lazy" src="assets/images/navbar/logo-icon.svg" routerLink="/{{langCode$()}}" alt="card4games"
            width="32" height="32" />
        </span>
      </div>

      <div class="nav-search d-none d-md-block">
        <ng-template [ngTemplateOutlet]="searchNav"></ng-template>
      </div>

      <div class="search-icon d-block d-md-none" *ngIf="!disableSearch">
        <i class="pi pi-search align-middle" routerLink="/{{langCode$()}}/search"></i>
      </div>

      <div class="nav-icons">
        <ng-template [ngTemplateOutlet]="navIcons"></ng-template>
      </div>
    </div>
  </nav>
</section>

<!-- navbar-mobile -->
<section class="navbar-mobile d-block d-md-none" [class.scrolled]="isScrolled">
  <div class="container">
    <div class="nav-right-side">
      <div class="categories">
        <button class=" border-0 overlay-panel-toggle" type="button" (click)="mainCategoryOP.toggle($event)">
          <i class="pi pi-bars"></i>
        </button>
        <p-overlayPanel #mainCategoryOP>
          <ul class="dropdown-nav" (click)="mainCategoryOP.toggle($event)">
            <div class="px-2 mb-2"> <img loading="lazy"
                [src]="isLight ? 'assets/images/navbar/logo-light.svg' : 'assets/images/navbar/logo-dark.svg'"
                class="mb-block mb-2 categories-logo" alt="card4games" routerLink="/{{langCode$()}}" /></div>
            <div routerLink="/{{langCode$()}}" routerLinkActive="active" class="mb-2">
              <span class="pointer">{{ 'navbar.mobileMenu.home' | translate }}</span>
            </div>
            <!-- Categories -->
            <div *ngFor="let item of mainCategoryList" routerLink="/{{langCode$()}}/categories/{{ item.slug }}"
              routerLinkActive="active" (click)="mainCategoriesLocal(item.name!)" class="mb-2 categories">
              <span class="pointer">{{ item.name?.[langCode$()] }}</span>
            </div>
          </ul>
        </p-overlayPanel>
      </div>
      <div class="logo">
        <img loading="lazy" src="assets/images/navbar/logo-icon.svg" alt="card4games" routerLink="/{{langCode$()}}" />
      </div>
    </div>
    <div class="nav-left-side user" *ngIf="user$()?._id">
      <div class="search-icon navbar-border-right px-2" routerLink="/{{langCode$()}}/search" *ngIf="!disableSearch">
        <i class="pi pi-search"></i>
      </div>
      <div class="regional-setting navbar-border-right " *ngIf="!disableCurrency">
        <app-nav-regional></app-nav-regional>
      </div>

      <button class="theme-toggle border-0" type="button" (click)="toggleTheme()"
        [attr.aria-label]="isLight ? 'Dark mode' : 'Light mode'">
        <i class="pi" [ngClass]="isLight ? 'pi-moon' : 'pi-sun'"></i>
      </button>

      <button class="py-0 border-0 overlay-panel-toggle user-icon pic navbar-border-right"
        (click)="userSettingOP.toggle($event)">
        <p *ngIf="!user$()?.avatar">{{ user$()?.name?.slice(0, 2) }}</p>

        <img loading="lazy" *ngIf="user$()?.avatar" [src]="user$()?.avatar" [alt]="user$()?.name"
          class="rounded-circle" />
      </button>

      <p-overlayPanel #userSettingOP>
        <div class="user-dropdown">
          <ul class="user-list list-unstyled rounded-3" (click)="userSettingOP.toggle($event)">
            <!-- User Info -->
            <li class="user-setting-link username">
              <span class="user-icon border-0 ps-0">
                <p *ngIf="!user$()?.avatar">{{ user$()?.name?.slice(0, 2) }}</p>
                <img loading="lazy" *ngIf="user$()?.avatar" [src]="user$()?.avatar" [alt]="user$()?.name" width="30"
                  height="30" class="rounded-circle me-2" />
              </span>
              <div class="customer">
                <span class="customer-name">
                  {{ user$()?.name }}
                </span>
                <span class="customer-email">
                  {{ user$()?.email }}
                </span>
              </div>
            </li>

            <!-- User Links -->
            <li class="user-setting-link" routerLink="/{{langCode$()}}/settings/profile" routerLinkActive="active">
              <i class="pi pi-user"></i> {{ 'navbar.userMenu.profile' | translate }}
            </li>
            <li class="user-setting-link" routerLink="/{{langCode$()}}/settings/cart" routerLinkActive="active">
              <i class="pi pi-shopping-cart"></i>
              <div class="label">
                {{ 'navbar.userMenu.cart' | translate }}
                <div class="count" *ngIf="cartQuantity$()">{{ cartQuantity$() > 99 ? '99+' : cartQuantity$() }}</div>
              </div>
            </li>
            <li class="user-setting-link" routerLink="/{{langCode$()}}/settings/orders" routerLinkActive="active">
              <i class="pi pi-book"></i> {{ 'navbar.userMenu.orders' | translate }}
            </li>
            <li class="user-setting-link" routerLink="/{{langCode$()}}/settings/wallets" routerLinkActive="active"
              *ngIf="!showWallet">
              <i class="pi pi-wallet"></i> {{ 'navbar.userMenu.wallets' | translate }}
            </li>
            <li class="user-setting-link" routerLink="/{{langCode$()}}/settings/tickets" routerLinkActive="active">
              <i class="pi pi-ticket"></i> {{ 'navbar.userMenu.tickets' | translate }}
            </li>
            <li class="user-setting-link" routerLink="/{{langCode$()}}/settings/notification" routerLinkActive="active">
              <i class="pi pi-bell"></i>
              <div class="label">
                {{ 'navbar.userMenu.notification' | translate }}
                <div class="count" *ngIf="unreadNotificationCount">{{unreadNotificationCount > 99 ? '+99' :
                  unreadNotificationCount}}</div>
              </div>
            </li>

            <!-- Logout -->
            <li class="user-setting-link logout" (click)="logout(); userListNav = false">
              <i class="pi pi-sign-out"></i>
              {{ 'navbar.userMenu.logout' | translate }}
            </li>
          </ul>
        </div>
      </p-overlayPanel>

      <div class="balance d-flex align-items-center" *ngIf="selectedWallet">
        <i class="fa-solid fa-coins coins-icon"></i>
        <div style="text-wrap-mode: nowrap;">
          {{ selectedWallet.balance | number : "1.2" }}
        </div>
      </div>
    </div>
    <div class="nav-left-side no-user" *ngIf="!user$()?._id">
      <div class="search-icon navbar-border-right" routerLink="/{{langCode$()}}/search">
        <i class="pi pi-search"></i>
      </div>
      <div class="regional-setting navbar-border-right">
        <app-nav-regional></app-nav-regional>
      </div>

      <button class="theme-toggle border-0" type="button" (click)="toggleTheme()"
        [attr.aria-label]="isLight ? 'Dark mode' : 'Light mode'">
        <i class="pi" [ngClass]="isLight ? 'pi-moon' : 'pi-sun'"></i>
      </button>

      <div class="login px-1">
        <button class=" border-0 overlay-panel-toggle" type="button" (click)="loginOP.toggle($event)">
          <i class="pi pi-user fs-5"></i>
        </button>
        <p-overlayPanel #loginOP>
          <div class="login-dropdown">
            <ul class=" login bg-transparent">
              <div class="login-list d-flex flex-column align-items-center justify-content-center rounded-3">
                <img loading="lazy" src="assets/images/navbar/drop-downs/login.webp" alt="" width="100" height="100" />
                <button class="btn-main w-100 m-0 mb-3" routerLink="/{{langCode$()}}/auth/signin" name="login">
                  {{ 'navbar.auth.login' | translate }}
                </button>
                <button class="btn-main w-100 glass m-0" routerLink="/{{langCode$()}}/auth/signup" name="signup">
                  {{ 'navbar.auth.signup' | translate }}
                </button>
              </div>
            </ul>
          </div>
        </p-overlayPanel>
      </div>
    </div>
  </div>
</section>